<template>
  <div class="p-0 mt-3">
    
    <VueTailwindDatepicker 
     :autoApply="true"
     :shortcuts="false" 
     :useRange="useRange"  :formatter="formatter"
      :startFrom="startFrom"  
      v-model="dateValue" 
       :i18n="lang"
      @update:modelValue="handleApply"  />


  </div>
</template>


<script>
import { ref } from 'vue'
import VueTailwindDatepicker from 'vue-tailwind-datepicker'
import i18n from '@/i18n';

export default {
  components: {
    VueTailwindDatepicker
  },
  props: ['fechasSeleccionadas'],
  emits: ['getFecCalendar'],
  mounted() {
     this.lang =  i18n.global.locale.value;
  },
  data() {
    return {
      showRegularDate: true,
      checkin: '',
      placeholder:'Seleccione dias',
      startFrom: '',
      dateValue:  ref(''),
      formatter: ref({
        date: 'DD MM YYYY',
        month: 'MMM',

      }),
      lang:''

    }
  },
  watch: {
    fechasSeleccionadas(value) {
      this.dateValue = []
      this.startFrom = value[0]
      this.dateValue = value
    },
    dateValue() {

     
    },
  },
  methods: {
    closeDatePickerPopup() {
   
    
      // here you have access to this.regularDate
      // and you could do whatever you want with this.regularDate
    },
     handleApply(){
     
      //console.log(this.dateValue, "<--");
      this.$emit("getFecCalendar", this.dateValue)
    },
    getFecCalendar() {

      //console.log(this.dateValue, "<--");
      this.$emit("getFecCalendar", this.dateValue)


    },
  },
}
</script>